import { type FC, type JSX, cloneElement, useMemo } from 'react';

import { useListingAppContext } from '@/microfrontends/listing/shared/context/ListingAppContext';
import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { WrapElementsSpacer } from '@/packages/shared-ui';
import { isLastListItem } from '@/packages/utils/array';

import { badgesCollection } from './internal/mappers/badgesCollection';
import { type GalleryBadgesTypes } from './types';

/**
 * @description Данная конструкция нужна для того, что бы логировать случаи, когда бекенд присылает бейдж, но фронтенд
 *   о нём не знает
 */
const unknownLoggedBadges = new Set<GalleryBadgesTypes>();

export const CardFeatureLabelsContainer: FC = () => {
  const { logger } = useListingAppContext();
  const {
    media: { badges },
  } = useCardOfferDataContext();

  const badgesViews = useMemo(() => {
    return badges.reduce((accumulator, badge, index, array) => {
      const badgeView = badgesCollection.get(badge)?.({
        tooltipPlacement: isLastListItem(array, index) ? 'bottom-end' : 'bottom',
      });

      if (badgeView) {
        accumulator.push(cloneElement(badgeView, { key: badge }));
      } else if (!unknownLoggedBadges.has(badge)) {
        logger.warning(
          `Не реализован бейдж галереи, нужно добавить бейдж с типом: ${badge} или на оборот удалить его так как визуала под этот тип нет`,
          { domain: '@/shared/components/CardFeatureLabels/CardFeatureLabelsContainer.tsx' },
        );

        unknownLoggedBadges.add(badge);
      }

      return accumulator;
    }, Array.of<JSX.Element>());
  }, [badges, logger]);

  return (
    <WrapElementsSpacer horizontalSpace={8} verticalSpace={8}>
      {badgesViews}
    </WrapElementsSpacer>
  );
};
